import React from 'react';
import { Inline } from '@styleseat/ui';
import Image from '../../Image';

import amexIconMinimal from '../../../../../images/cc_amex_minimal.png';
import discoverIconMinimal from '../../../../../images/cc_discover_minimal.png';
import masterCardIconMinimal from '../../../../../images/cc_mastercard_minimal.png';
import visaIconMinimal from '../../../../../images/cc_visa_minimal.png';
import amexIcon from '../../../../../images/cc_amex.png';
import discoverIcon from '../../../../../images/cc_discover.png';
import masterCardIcon from '../../../../../images/cc_mastercard.png';
import visaIcon from '../../../../../images/cc_visa.png';

type StripeCardIconsProps = {
  /** Use minimalized versions of the card icons */
  minimal?: boolean,
  size?: number,
};

type CCIconDimension = {
  width: number,
  height: number,
};

const NORMAL_ICON: CCIconDimension = {
  width: 35,
  height: 20,
};

const MINIMAL_ICON: CCIconDimension = {
  width: 22,
  height: 15,
};

enum ASPECT_RATIO {
  MINIMAL = MINIMAL_ICON.width / MINIMAL_ICON.height,
  NORMAL = NORMAL_ICON.width / NORMAL_ICON.height,
}

const StripeCardIcons: React.FC<StripeCardIconsProps> = ({
  minimal = false,
  size = null,
}) => {
  const height = size ?? (minimal ? MINIMAL_ICON.height : NORMAL_ICON.height);

  let width;
  if (size) {
    width = minimal ? size * ASPECT_RATIO.MINIMAL : size * ASPECT_RATIO.NORMAL;
  } else {
    width = minimal ? MINIMAL_ICON.width : NORMAL_ICON.width;
  }

  return (
    <Inline space={4}>
      <Image
        source={{
          uri: minimal ? visaIconMinimal : visaIcon,
          height,
          width,
        }}
      />
      <Image
        source={{
          uri: minimal ? masterCardIconMinimal : masterCardIcon,
          height,
          width,
        }}
      />
      <Image
        source={{
          uri: minimal ? discoverIconMinimal : discoverIcon,
          height,
          width,
        }}
      />
      <Image
        source={{
          uri: minimal ? amexIconMinimal : amexIcon,
          height,
          width,
        }}
      />
    </Inline>
  );
};
export default StripeCardIcons;
